import '../assets/NcDateTimePicker-q_BLnhHU.css';
import { r as c, F as u, a as l } from "../chunks/_l10n-BaNxGGXy.mjs";
import { G as p } from "../chunks/GenRandomId-BW3iYFf9.mjs";
import { N as m } from "../chunks/NcTimezonePicker-CH1lkCMF.mjs";
import { N as d } from "../chunks/NcPopover--V3R3EKV.mjs";
import { n as o } from "../chunks/_plugin-vue2_normalizer-Bj5bLKV4.mjs";
import { getMonthNames as f, getMonthNamesShort as h, getDayNames as _, getDayNamesShort as g, getDayNamesMin as y, getFirstDay as v } from "@nextcloud/l10n";
import C from "vue2-datepicker";
import { S as k } from "../chunks/ScopeComponent-Dz4pyD77.mjs";
c(u);
const w = {
  name: "CalendarBlankIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var z = function() {
  var e = this, t = e._self._c;
  return t("span", e._b({ staticClass: "material-design-icon calendar-blank-icon", attrs: { "aria-hidden": e.title ? null : !0, "aria-label": e.title, role: "img" }, on: { click: function(a) {
    return e.$emit("click", a);
  } } }, "span", e.$attrs, !1), [t("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [t("path", { attrs: { d: "M19,19H5V8H19M16,1V3H8V1H6V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3H18V1" } }, [e.title ? t("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, b = [], D = /* @__PURE__ */ o(
  w,
  z,
  b,
  !1,
  null,
  null,
  null,
  null
);
const M = D.exports, S = {
  name: "WebIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var T = function() {
  var e = this, t = e._self._c;
  return t("span", e._b({ staticClass: "material-design-icon web-icon", attrs: { "aria-hidden": e.title ? null : !0, "aria-label": e.title, role: "img" }, on: { click: function(a) {
    return e.$emit("click", a);
  } } }, "span", e.$attrs, !1), [t("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [t("path", { attrs: { d: "M16.36,14C16.44,13.34 16.5,12.68 16.5,12C16.5,11.32 16.44,10.66 16.36,10H19.74C19.9,10.64 20,11.31 20,12C20,12.69 19.9,13.36 19.74,14M14.59,19.56C15.19,18.45 15.65,17.25 15.97,16H18.92C17.96,17.65 16.43,18.93 14.59,19.56M14.34,14H9.66C9.56,13.34 9.5,12.68 9.5,12C9.5,11.32 9.56,10.65 9.66,10H14.34C14.43,10.65 14.5,11.32 14.5,12C14.5,12.68 14.43,13.34 14.34,14M12,19.96C11.17,18.76 10.5,17.43 10.09,16H13.91C13.5,17.43 12.83,18.76 12,19.96M8,8H5.08C6.03,6.34 7.57,5.06 9.4,4.44C8.8,5.55 8.35,6.75 8,8M5.08,16H8C8.35,17.25 8.8,18.45 9.4,19.56C7.57,18.93 6.03,17.65 5.08,16M4.26,14C4.1,13.36 4,12.69 4,12C4,11.31 4.1,10.64 4.26,10H7.64C7.56,10.66 7.5,11.32 7.5,12C7.5,12.68 7.56,13.34 7.64,14M12,4.03C12.83,5.23 13.5,6.57 13.91,8H10.09C10.5,6.57 11.17,5.23 12,4.03M18.92,8H15.97C15.65,6.75 15.19,5.55 14.59,4.44C16.43,5.07 17.96,6.34 18.92,8M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" } }, [e.title ? t("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, P = [], $ = /* @__PURE__ */ o(
  S,
  T,
  P,
  !1,
  null,
  null,
  null,
  null
);
const H = $.exports, i = {
  date: "YYYY-MM-DD",
  datetime: "YYYY-MM-DD H:mm:ss",
  year: "YYYY",
  month: "YYYY-MM",
  time: "H:mm:ss",
  week: "w"
}, Y = {
  name: "NcDateTimePicker",
  components: {
    CalendarBlank: M,
    DatePicker: C,
    NcPopover: d,
    NcTimezonePicker: m,
    Web: H
  },
  inheritAttrs: !1,
  props: {
    clearable: {
      type: Boolean,
      default: !1
    },
    minuteStep: {
      type: Number,
      default: 10
    },
    type: {
      type: String,
      default: "date"
    },
    format: {
      type: String,
      default: null
    },
    formatter: {
      type: Object,
      default: null
    },
    lang: {
      type: Object,
      default: null
    },
    /**
     * The value to initialize, but also two-way bind the selected date. The date is – like the `Date` object in
     * JavaScript – tied to UTC. The selected time zone does not have an influence of the selected time and date
     * value. You have to translate the time yourself when you want to factor in time zones.
     */
    // eslint-disable-next-line
    value: {
      default: () => /* @__PURE__ */ new Date()
    },
    /**
     * The preselected IANA time zone ID for the time zone picker, only relevant in combination with `:show-timezone-select="true"`. Example: `Europe/Berlin`. The prop supports two-way binding through the .sync modifier.
     */
    timezoneId: {
      type: String,
      default: "UTC"
    },
    showTimezoneSelect: {
      type: Boolean,
      default: !1
    },
    highlightTimezone: {
      type: Boolean,
      default: !1
    },
    appendToBody: {
      type: Boolean,
      default: !1
    },
    showWeekNumber: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: null
    }
  },
  emits: [
    "update:value",
    "update:timezone-id"
  ],
  setup() {
    return {
      timezoneDialogHeaderId: "timezone-dialog-header-".concat(p())
    };
  },
  data() {
    return {
      showTimezonePopover: !1,
      tzVal: this.timezoneId
    };
  },
  computed: {
    /**
     * Datepicker language
     * https://github.com/mengxiong10/vue2-datepicker/blob/master/locale.md
     *
     * @return {object}
     */
    defaultLang() {
      return {
        formatLocale: {
          months: f(),
          monthsShort: h(),
          weekdays: _(),
          weekdaysShort: g(),
          weekdaysMin: y(),
          // 0 = sunday, 1 = monday
          firstDayOfWeek: v()
        },
        monthFormat: "MMM"
      };
    },
    /**
     * Translated placeholder
     *
     * @return {string}
     */
    defaultPlaceholder() {
      return this.type === "time" ? l("Pick a time") : this.type === "month" ? l("Pick a month") : this.type === "year" ? l("Pick a year") : this.type === "week" ? l("Pick a week") : this.type === "date" ? l("Pick a date") : l("Pick a date and a time");
    },
    /**
     * If format is not provided, try to match the type
     * or fallback to 'date'
     *
     * @return {string}
     */
    formatTypeMap() {
      var r;
      return (r = i[this.type]) != null ? r : i.date;
    },
    /**
     * The formatter used for the vue-datepicker to fix nextcloud-libraries/nextcloud-vue#5044
     */
    internalFormatter() {
      var e;
      return {
        getWeek: (t) => {
          const a = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate()));
          a.setUTCDate(a.getUTCDate() + 4 - (a.getUTCDay() || 7));
          const n = new Date(Date.UTC(a.getUTCFullYear(), 0, 1));
          return Math.ceil(((a - n) / 864e5 + 1) / 7);
        },
        // allow to override it by users using the `formatter` prop
        ...(e = this.formatter) != null ? e : {}
      };
    }
  },
  methods: {
    t: l,
    handleSelectYear(r) {
      const e = this.$refs.datepicker.currentValue;
      if (e)
        try {
          const t = new Date(new Date(e).setFullYear(r));
          this.$refs.datepicker.selectDate(t);
        } catch {
          console.error("Invalid value", e, r);
        }
    },
    handleSelectMonth(r) {
      const e = this.$refs.datepicker.currentValue;
      if (e)
        try {
          const t = new Date(new Date(e).setMonth(r));
          this.$refs.datepicker.selectDate(t);
        } catch {
          console.error("Invalid value", e, r);
        }
    },
    /**
     * Toggles the visibility of the time zone popover
     */
    toggleTimezonePopover() {
      this.showTimezoneSelect && (this.showTimezonePopover = !this.showTimezonePopover);
    }
  }
};
var N = function() {
  var e = this, t = e._self._c;
  return t("DatePicker", e._g(e._b({ ref: "datepicker", attrs: { "append-to-body": e.appendToBody, clearable: e.clearable, format: e.format ? e.format : e.formatTypeMap, formatter: e.internalFormatter, lang: e.lang ? e.lang : e.defaultLang, "minute-step": e.minuteStep, placeholder: e.placeholder ? e.placeholder : e.defaultPlaceholder, "popup-class": { "show-week-number": e.showWeekNumber }, "show-week-number": e.showWeekNumber, type: e.type, value: e.value }, on: { "select-year": e.handleSelectYear, "select-month": e.handleSelectMonth, "update:value": function(a) {
    return e.$emit("update:value", e.value);
  } }, scopedSlots: e._u([{ key: "icon-calendar", fn: function() {
    return [e.showTimezoneSelect ? t("NcPopover", { attrs: { "popup-role": "dialog", shown: e.showTimezonePopover, "popover-base-class": "timezone-select__popper" }, on: { "update:shown": function(a) {
      e.showTimezonePopover = a;
    } }, scopedSlots: e._u([{ key: "trigger", fn: function({ attrs: a }) {
      return [t("button", e._b({ staticClass: "datetime-picker-inline-icon", class: { "datetime-picker-inline-icon--highlighted": e.highlightTimezone }, on: { mousedown: function(n) {
        return n.stopPropagation(), n.preventDefault(), (() => {
        }).apply(null, arguments);
      } } }, "button", a, !1), [t("Web", { attrs: { size: 20 } })], 1)];
    } }], null, !1, 270852355) }, [t("div", { attrs: { role: "dialog", "aria-labelledby": e.timezoneDialogHeaderId } }, [t("div", { staticClass: "timezone-popover-wrapper__label" }, [t("strong", { attrs: { id: e.timezoneDialogHeaderId } }, [e._v(" " + e._s(e.t("Please select a time zone:")) + " ")])]), t("NcTimezonePicker", { staticClass: "timezone-popover-wrapper__timezone-select", on: { input: function(a) {
      return e.$emit("update:timezone-id", arguments[0]);
    } }, model: { value: e.tzVal, callback: function(a) {
      e.tzVal = a;
    }, expression: "tzVal" } })], 1)]) : t("CalendarBlank", { attrs: { size: 20 } })];
  }, proxy: !0 }, e._l(e.$scopedSlots, function(a, n) {
    return { key: n, fn: function(s) {
      return [e._t(n, null, null, s)];
    } };
  })], null, !0) }, "DatePicker", e.$attrs, !1), e.$listeners));
}, V = [], B = /* @__PURE__ */ o(
  Y,
  N,
  V,
  !1,
  null,
  "56b96a48",
  null,
  null
);
const F = B.exports;
/**
 * @copyright Copyright (c) 2018 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
k(F);
export {
  F as default
};
